import React from 'react';

type Columns = '45-55' | '55-45' | 'one-column' | '50-50';

type CardWrapperProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  columns?: Columns;
  tabletColumns?: Columns; //
  width?: string; //
  paddingClassName?: string;
  gapClassName?: string; //
  className?: string;
};

const columnClasses: Record<Columns, string> = {
  '45-55': 'lg:grid-cols-[45%_55%]',
  '55-45': 'lg:grid-cols-[55%_45%]',
  '50-50': 'lg:grid-cols-[50%_50%]',
  'one-column': 'lg:grid-cols-[100%]',
};

const tabletColumnClasses: Record<Columns, string> = {
  '45-55': 'md:grid-cols-[45%_55%]',
  '55-45': 'md:grid-cols-[55%_45%]',
  '50-50': 'md:grid-cols-[50%_50%]',
  'one-column': 'md:grid-cols-[100%]',
};

const CardWrapper = ({
  children,
  columns = '45-55',
  tabletColumns,
  width = 'w-full',
  className = '',
  paddingClassName = 'p-8',
  gapClassName = '',
  ...props
}: CardWrapperProps) => {
  const isOneColumn = columns === 'one-column';
  const effectiveTabletColumns = tabletColumns ?? columns;

  return (
    <div
      className={[
        width,
        paddingClassName,
        gapClassName,
        'items-start justify-start overflow-hidden rounded-2xl bg-white shadow-md',

        // base layout
        isOneColumn ? 'flex flex-col' : 'grid grid-cols-1',

        // tablet layout (md..)
        !isOneColumn ? tabletColumnClasses[effectiveTabletColumns] : '',

        // desktop layout (lg..)
        !isOneColumn ? columnClasses[columns] : '',

        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...props}
    >
      {children}
    </div>
  );
};

export default CardWrapper;
